import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const UserMenuNavLinkDefaultProps = {
  ...ClassNameDefaultProps,
  context: null,
  disabled: false,
};

export const UserMenuNavLinkPropTypes = {
  ...ClassNamePropTypes,
  context: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};
